import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  Typography,
  makeStyles,
  Popper,
  MenuList,
  MenuItem,
  Grow,
  Paper,
  ClickAwayListener,
  Select
} from "@material-ui/core/";
import PhoneIcon from "@material-ui/icons/Phone";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useSelector, useDispatch } from "react-redux";
import { findFlagUrlByIso2Code } from "country-flags-svg";
import { clearLoginData, isLoggedInUpdate } from "../../../../reduxSlices/loginSlice";
import {
  clearErrorStatusCode,
  clearErrorMessage,
  clearApplicationData,
  clearApplicantStatus,
} from "../../../../reduxSlices/applicationSlice";
import {
  removeWebSelectclassData,
  removeElementsFromArray,
} from "../../../../reduxSlices/selectClassSlice";
import { Link, withRouter } from "react-router-dom";
import {updateLanguage} from '../../../../reduxSlices/languageSlice';

import style from "./infoBar.module.css";
import ResetPasswordModal from '../../../ResetPassword';
import localizedStrings from '../../../../utils/localize';
import logo from "../../../../assests/navBarLogo.png";

const useStyle = makeStyles((theme) => ({
  main: {
    marginTop: "0.5rem",
    display: "flex",
    alignItems: "center",
  },
  contentIcon: {
    fontSize: "1.3rem",
    opacity: 1,
    color: "#fff",
  },
  contentFont: {
    fontSize: "0.9rem",
    color: "#fff",
  },
  lang:{
    color:"#fff",
    marginLeft:"1rem"
  },
  grow: {
    height:"100%",
    padding:"11px",

  },
}));

const InfoBarItems = (props) => {
  const classes = useStyle(props);
  const [open, setOpen] = useState(false);
  const [modalState,setModalState]=useState(false);
  const language =useSelector(state=> state.language.language);
  const [lang,setLang]=useState(language);
  const anchorRef = useRef(null);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.loginRequest.isLoggedIn);

  useEffect(()=>{
    if(window.localStorage.getItem("hasReloaded") === "true"){
      window.location.reload(true);
      window.localStorage.setItem('hasReloaded', "false");
    }
  },[window.localStorage.getItem("hasReloaded")]);

  const handelLogout = () => {
    dispatch(clearLoginData());
    dispatch(removeWebSelectclassData([]));
    dispatch(removeElementsFromArray([]));
    window.localStorage.removeItem("x-auth-token");;
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    window.localStorage.removeItem("x-auth-email");
    window.localStorage.removeItem("x-auth-mobile");
    window.localStorage.removeItem("ses_applicantid");
    window.localStorage.removeItem("studentId");
    window.localStorage.setItem("hasReloaded", true);
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    dispatch(clearApplicationData());
    dispatch(clearApplicantStatus());
    props.history.push("/login");
    setOpen(false);
  };
  localizedStrings.setLanguage(language)
  useEffect(()=>{
    setLang(language);
    localizedStrings.setLanguage(language)
  },[language]);

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  const handleLangChange=(event)=>{
    if(event.target.value){
      dispatch(updateLanguage(event.target.value))
      window.localStorage.setItem("lang",event.target.value)
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = useRef(open);
  useEffect(() => {
    // if (prevOpen.current === true && open === false) {
    //   anchorRef.current.focus();
    // }

    prevOpen.current = open;
  }, [open]);

  const showModal=(event)=>{
    handleClose(event);
    setModalState(true);
  }

  const handleModalClose=()=>{
    setModalState(false);
  }

  return (
    <Grid item container className={classes.main}>
      <ResetPasswordModal open={modalState}  onClose={handleModalClose} />
      <Typography component="div" className={style.leftContainer}>
      <div className={`${classes.grow} ${style.mainContent}`}>
        <Link to="/">
          <div className={classes.logoResponsive}>
            <img src={logo} width="100%" alt="logo" />
          </div>
        </Link>
      </div>
      </Typography>
      <Typography component="div" className={style.rightContainer}>
        {isLoggedIn || window.localStorage.getItem("isUserLoggedIn") ? (
          <Typography
            component="div"
            className={style.mainContent}
            style={{ cursor: "pointer" }}
          >
            <Typography
              component="div"
              ref={anchorRef}
              onClick={handleToggle}
              style={{
                marginTop: "6px",
                display: "flex",
              }}
            >
              <span className={classes.contentFont}>
                {window.localStorage.getItem("x-auth-fullname")}
              </span>
              <ExpandMoreIcon className={classes.contentIcon} />
            </Typography>
            <Popper
              open={open}
              anchorEl={anchorRef.current}
              role={undefined}
              transition
              disablePortal
              style={{ zIndex: 100 }}
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "center top" : "center bottom",
                  }}
                  className={style.subMenuPosition}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList
                        autoFocusItem={open}
                        id="menu-list-grow"
                        onKeyDown={handleListKeyDown}
                      >
                        <MenuItem onClick={showModal}>
                          {localizedStrings.navigation.changePassword}
                        </MenuItem>
                        <MenuItem onClick={handelLogout}> {localizedStrings.navigation.logout}</MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </Typography>
        ) : (
          <></>
        )}
        <Typography className={style.mainContent} component="div">
                <Select 
                className={classes.lang}
                value={lang}
                onChange={handleLangChange}
                >
                    <MenuItem value="en">
                    English</MenuItem>
                  <MenuItem value="fr">
                    Français canadien</MenuItem>
                </Select>
        </Typography>

      </Typography>
    </Grid>
  );
};

export default withRouter(InfoBarItems);
